import { lazy, Suspense } from "react";
import { Cabeca } from "../comp.tsx";

// O conteúdo dos 122 mapas pesa mais que o resto do app: fica em bloco próprio, carregado ao abrir o módulo.
const Lista = lazy(() => import("./mapas.tsx").then((m) => ({ default: m.TelaMapas })));
const Mapa = lazy(() => import("./mapas.tsx").then((m) => ({ default: m.TelaMapa })));

export function TelaMapas() {
  return (
    <Suspense fallback={<Cabeca titulo="Mapas mentais" />}>
      <Lista />
    </Suspense>
  );
}

export function TelaMapa() {
  return (
    <Suspense fallback={<Cabeca titulo="Mapa mental" />}>
      <Mapa />
    </Suspense>
  );
}
